import { PromotionContextProvider } from "src/contexts/promotion.context";
import { PromoWrapper } from "./ProductList.styled";
import { BrandsPromo } from "src/molecules/BrandsPromo";
import { useState } from "react";
import NoSSR from "src/atoms/NoSSR";
import { PROMOTION_TYPES } from "src/utils/constants";
import type { ProductListType } from "src/types/product-listing";

function Promotion({
  slug,
  productListType,
}: {
  slug: string;
  productListType: ProductListType;
}): JSX.Element | null {
  const [displayPromo, setDisplayPromo] = useState(true);
  const promotionType = PROMOTION_TYPES[productListType];

  if (!displayPromo || !promotionType) {
    return null;
  }

  return (
    <NoSSR>
      <PromoWrapper>
        <PromotionContextProvider>
          <BrandsPromo
            slug={slug}
            callback={setDisplayPromo}
            promotionType={promotionType}
          />
        </PromotionContextProvider>
      </PromoWrapper>
    </NoSSR>
  );
}

export { Promotion };
